<template>
    <div>

        <div class="row button-row">
            <div class="col">
                <h4>When are you looking to sell?</h4>
            </div>
        </div>
        <div class="row button-row">
            <div class="col">
                <b-button class="button" pill variant="outline-secondary" :pressed="isSelected('Now')"
                          @click="updateTimeFrame('Now')">Now
                </b-button>
            </div>
        </div>
        <div class="row button-row">
            <div class="col">
                <b-button class="button" pill variant="outline-secondary" :pressed="isSelected('1 to 3 Months')"
                          @click="updateTimeFrame('1 to 3 Months')">1 - 3 months
                </b-button>
            </div>
        </div>
        <div class="row button-row">
            <div class="col">
                <b-button class="button" pill variant="outline-secondary" :pressed="isSelected('3 to 6 Months')"
                          @click="updateTimeFrame('3 to 6 Months')">3 - 6 months
                </b-button>
            </div>
        </div>
        <div class="row button-row">
            <div class="col">
                <b-button class="button" pill variant="outline-secondary" :pressed="isSelected('6 to 9 Months')"
                          @click="updateTimeFrame('6 to 9 Months')">6 - 9 months
                </b-button>
            </div>
        </div>
        <div class="row button-row">
            <div class="col">
                <b-button class="button" pill variant="outline-secondary" :pressed="isSelected('9 to 12 Months')"
                          @click="updateTimeFrame('9 to 12 Months')">9 - 12 months
                </b-button>
            </div>
        </div>
        <div class="row button-row">
            <div class="col">
                <b-button class="button" pill variant="outline-secondary" :pressed="isSelected('9 to 12 Months')"
                          @click="updateTimeFrame('Over 1 Year')">Over 1 year
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
    import {saveField} from "@/services/apiService";

    export default {
        name: "EstimateTimeFrame",
        props: ['value'],
        model: {
            prop: 'value',
            event: 'selected'
        },
        data() {
            return {
                estimatedTimeFrame: null
            }
        },
        methods: {
            updateTimeFrame: function (value) {
                this.estimatedTimeFrame = value;
                this.$emit('selected', value);
                saveField('Timeframe_to_sell', this.estimatedTimeFrame);
            },
            isSelected: function (value) {
                return this.value === value;
            }

        }
    }
</script>

<style scoped>
    .button-row {
        padding: 5px;
    }

    .button {
        margin: auto;
        left: 0;
        right: 0;
        padding: 10px;
        width: 175px;
    }
</style>
